import { DayPriceOverride } from '../types';

const PRICE_OVERRIDES_KEY = 'pricing-widget-overrides';

export const savePriceOverrides = (overrides: DayPriceOverride[]): void => {
    try {
        localStorage.setItem(PRICE_OVERRIDES_KEY, JSON.stringify(overrides));
    } catch (error) {
        console.error('Failed to save price overrides to localStorage:', error);
    }
};

export const loadPriceOverrides = (): DayPriceOverride[] => {
    try {
        const stored = localStorage.getItem(PRICE_OVERRIDES_KEY);
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.error('Failed to load price overrides from localStorage:', error);
        return [];
    }
};

export const clearPriceOverrides = (): void => {
    try {
        localStorage.removeItem(PRICE_OVERRIDES_KEY);
    } catch (error) {
        console.error('Failed to clear price overrides from localStorage:', error);
    }
}; 